import { AbstractPmsApiService } from "./abstract.service";
import { BankTransferPaymentOption } from "../models";

/**
 * @class BankTransferPaymentOptionPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<BankTransferPaymentOption>}
 */
export class BankTransferPaymentOptionPmsApiService extends AbstractPmsApiService {
    
    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {
        
        return '/property/:propertyId/bank-transfer-payment-option';
    }
    
    /**
     * @param {Object.<string, *>} attributes
     * @returns {BankTransferPaymentOption}
     * @protected
     */
    newModel(attributes, ...params) {
        
        return new BankTransferPaymentOption(attributes);
    }
    
    /**
     * @param {Property} property
     * @returns {Promise.<BankTransferPaymentOption>}
     */
    get (property) {
        
        const url = this.url({propertyId: property.id});
        
        return this.http
                   .get(url, {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {BankTransferPaymentOption} bankTransferPaymentOption
     * @param {Property} property
     * @returns {Promise.<BankTransferPaymentOption>}
     */
    updateOrCreate(bankTransferPaymentOption, property) {
        
        const url = this.url({propertyId: property.id});
        
        return this.http
                   .post(url, bankTransferPaymentOption.toObjectExcept('property'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/bank-transfer-payment-option.service.js